export default __webpack_public_path__ + "static/media/I27.af36f04b.jpg";